import React, { useCallback, useMemo } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { annotationMetadataAtom, frameCountAtom } from '../../../../labelling-v2/atoms/annotation-atoms';
import { frameRateAtom } from '../../../../labelling-v2/atoms/file-atoms';
import { dispatchAtom } from '../../../../labelling-v2/atoms/label-store-dispatch/dispatch';
import { EVENTS } from '../../../../labelling-v2/atoms/label-store-dispatch/events';
import { timeDisplayModeAtom } from '../../../../labelling-v2/atoms/tool-atoms';
import { currentFrameAtom } from '../../../../labelling-v2/atoms/video-playback-atoms';
import { hasKeyframeInRange } from '../../../../labelling-v2/utils/frame-span-utils';
import type { PROPAGATION_METHOD } from '../../../reducers/actions/constants';
import type { AnnotationTimelineConfigPropsT } from './modernised-annotation-timeline-modal/annotation-timeline-config';
import { AnnotationTimelineConfig } from './modernised-annotation-timeline-modal/annotation-timeline-config';
type PropsT = Omit<AnnotationTimelineConfigPropsT, 'currentFrame' | 'hasManualKeyFrameInRange' | 'annotationSequence' | 'maxFrames' | 'onPropagationMethodChange' | 'timeDisplayMode' | 'frameRate'>;
export const AnnotationTimelineConfigLabelStore = (props: PropsT) => {
  const currentPosition = useAtomValue(currentFrameAtom);
  const frameCount = useAtomValue(frameCountAtom);
  const metadata = useAtomValue(annotationMetadataAtom);
  const dispatch = useSetAtom(dispatchAtom);
  const frameRate = useAtomValue(frameRateAtom);
  const timeDisplayMode = useAtomValue(timeDisplayModeAtom);
  const handlePropagationMethodChange = useCallback((propagationMethod: (typeof PROPAGATION_METHOD)[keyof typeof PROPAGATION_METHOD]) => {
    dispatch({
      type: EVENTS.UPDATE_ANNOTATION_PROPAGATION_METHOD,
      propagationMethod
    });
  }, [dispatch]);
  const annotationSequence = useMemo(() => {
    const spans = metadata.get(props.annotationId)?.spans ?? [];
    return new Map(spans.map((span, i) => [String(i), span]));
  }, [metadata, props.annotationId]);
  const hasManualKeyFrameInRange = useCallback((start: number, end: number) => {
    const keyframes = metadata.get(props.annotationId)?.keyframes ?? [];
    return hasKeyframeInRange(start, end, keyframes);
  }, [metadata, props.annotationId]);
  return <AnnotationTimelineConfig {...props} currentFrame={currentPosition} timeDisplayMode={timeDisplayMode} hasManualKeyFrameInRange={hasManualKeyFrameInRange} annotationSequence={annotationSequence} maxFrames={frameCount} onPropagationMethodChange={handlePropagationMethodChange} frameRate={frameRate} />;
};